export default "__VITE_ASSET__bdce408b__"